<template>
  <el-form label-position="top" label-width="80px">
    <el-form-item label="时间范围">
      <el-date-picker
        v-model="form.timeRangeArr"
        type="daterange"
        size="mini"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="datePickerOption"
        value-format="yyyy-MM-dd"
        @change="handleTimeChange"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item label="环比时间范围">
      <el-date-picker
        v-model="form.rateTimeRangeArr"
        type="daterange"
        size="mini"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="datePickerOption"
        value-format="yyyy-MM-dd"
        @change="handleRateTimeChange"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item label="客户来源">
      <el-select size="mini" style="width:260px;" v-model="form.customerSource" placeholder="请选择" multiple>
        <el-option v-for="item in customerFlowSourcesUnion" :key="item.dataValue" :label="item.dataDisplay" :value="item.dataValue"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="意向车系">
      <el-select size="mini" style="width:260px;" v-model="form.intentionSeries" placeholder="请选择" multiple>
        <el-option v-for="item in seriesListClone" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>
<script>
import { 
  datePickerOption,
} from '../static/form-options'
import { deepClone } from '@/assets/js/util'

export default {
  name: 'StatisticsSearchForm',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
  },
  model: {
    prop: "form",
    event: "change"
  },
  data() {
    return {
      datePickerOption,
    }
  },
  computed: {
    baseInfo() {
      return this.$common.getBaseInfo()
    },
    // 客户来源
    customerFlowSourcesUnion() {
      return this.baseInfo.customerFlowSourcesUnion
    },
    // 页面对象
    pageVm() {
      return this.$parent.$parent
    },
    // 意向车系
    seriesListClone() {
      return deepClone(this.pageVm.seriesList)
    },
  },
  mounted() {},
  methods: {
    handleTimeChange(e) {
      // 计算环比日期
      if (e && e.length) {
        const momentDate1 = this.$moment(e[0], 'YYYY-MM-DD');
        const momentDate2 = this.$moment(e[1], 'YYYY-MM-DD');
        // 计算两个日期之间相差的天数
        const diffDays = momentDate2.diff(momentDate1, 'days');
        if (diffDays > 30) {
          const firstMonthDay = this.$moment().startOf('month').format('YYYY-MM-DD');
          const todayDate = this.$moment().format('YYYY-MM-DD');
          this.form.timeRangeArr = [firstMonthDay, todayDate];
          this.$message.error('时间范围只能选择一个月内')
          return
        }
        const dateRate1 = momentDate1.subtract(diffDays + 1, 'days').format('YYYY-MM-DD');
        const dateRate2 = momentDate2.subtract(diffDays + 1, 'days').format('YYYY-MM-DD');
        this.form.rateTimeRangeArr = [dateRate1, dateRate2]
      }
    },
    handleRateTimeChange(e) {
      // 计算环比日期
      if (e && e.length) {
        const momentDate1 = this.$moment(e[0], 'YYYY-MM-DD');
        const momentDate2 = this.$moment(e[1], 'YYYY-MM-DD');
        // 计算两个日期之间相差的天数
        const diffDays = momentDate2.diff(momentDate1, 'days');
        if (diffDays > 30) {
          const momentDate1 = this.$moment(this.form.timeRangeArr[0], 'YYYY-MM-DD');
          const momentDate2 = this.$moment(this.form.timeRangeArr[1], 'YYYY-MM-DD');
          // 计算两个日期之间相差的天数
          const diffDays = momentDate2.diff(momentDate1, 'days');
          const firstMonthDayRate = momentDate1.subtract(diffDays + 1, 'days').format('YYYY-MM-DD');
          const todayDateRate = momentDate2.subtract(diffDays + 1, 'days').format('YYYY-MM-DD');
          this.form.rateTimeRangeArr = [firstMonthDayRate, todayDateRate];
          this.$message.error('环比时间范围只能选择一个月内')
          return
        }
      }
    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item {
  margin-bottom: 5px;
}

::v-deep .el-form-item .el-form-item__label {
  line-height: 16px;
  padding-bottom: 3px;
}
</style>